import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export default function Cursor() {
  const dot = useRef(null);
  const [hover, setHover] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) return;
    setEnabled(true);
    document.body.classList.add("wam-cursor-hidden");
    const move = (e) => {
      if (!dot.current) return;
      dot.current.style.transform = `translate3d(${e.clientX - 6}px, ${e.clientY - 6}px, 0)`;
    };
    const over = (e) => {
      const t = e.target;
      if (t.closest("[data-cursor='hover'], a, button, [role='button'], input, select, textarea")) {
        setHover(true);
      } else {
        setHover(false);
      }
    };
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      document.body.classList.remove("wam-cursor-hidden");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, []);

  if (!enabled) return null;
  return (
    <motion.div
      ref={dot}
      aria-hidden
      className="wam-cursor pointer-events-none fixed left-0 top-0 z-[999]"
      animate={{
        width: hover ? 30 : 12,
        height: hover ? 30 : 12,
        backgroundColor: hover ? "rgba(201,168,76,0)" : "rgba(201,168,76,1)",
        borderColor: "rgba(201,168,76,1)",
        borderWidth: hover ? 1 : 0,
        marginLeft: hover ? -9 : 0,
        marginTop: hover ? -9 : 0,
      }}
      transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
      style={{ borderRadius: 999, mixBlendMode: "difference" }}
    />
  );
}
